<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="640px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="130px">
      <el-form-item
        label="企业名称：">
        {{ info.vendorName }}
      </el-form-item>
      <el-form-item
        label="服务产品："
        prop="serviceId">
        <service-select
          v-model="info.serviceId"
          :callback="
            (r) => {
              cb(r);
            }
          "
          style="width:100%" />
      </el-form-item>
      <el-form-item
        label="行业管理："
        prop="classId">
        <category-select
          v-model="info.classId"
          style="width:100%" />
      </el-form-item>
      <el-form-item
        label="二级类目/套餐："
        prop="serviceCategoryId">
        <category-service-select-new
          v-if="flag === 1"
          v-model="info.serviceCategoryId"
          style="width:100%"
          :callback="packageCallback"
          :option="options" />
        <category-service-select-new2
          v-if="flag === 0"
          v-model="info.serviceCategoryId"
          :callback="packageCallback"
          style="width:100%"
          :option="options" />
      </el-form-item>
      <template v-if="serviceInfo.serviceType === 2">
        <!-- <el-form-item
          label="送样地址："
          prop="sampleDeliveryAddressId">
          <delivery-select
            v-model="info.sampleDeliveryAddressId"
            style="width:100%" />
        </el-form-item> -->
        <el-form-item
          label="实验室："
          prop="labId">
          <lab-select
            v-model="info.labId"
            style="width:100%" />
        </el-form-item>
        <el-form-item
          label="检测标准："
          prop="testStandard">
          <el-input
            v-model="info.testStandard"
            type="textarea"
            :rows="4"
            :autosize="{ minRows: 2, maxRows: 4}"></el-input>
        </el-form-item>
        <el-form-item
          label="检测资质："
          prop="testQualification">
          <el-input
            v-model="info.testQualification"
            type="textarea"
            :rows="4"
            :autosize="{ minRows: 2, maxRows: 4}"></el-input>
        </el-form-item>
        <el-form-item
          label="抽样数量："
          prop="sampleQuantity">
          <el-input v-model="info.sampleQuantity"></el-input>
        </el-form-item>
      </template>
      <el-form-item
        :label="serviceInfo.serviceType === 2 ? '检测内容：' :'描述：'"
        prop="features">
        <el-input
          v-model="info.features"
          type="textarea"
          :rows="4"
          :autosize="{ minRows: 2, maxRows: 6}"></el-input>
      </el-form-item>
      <el-form-item
        label="周期："
        prop="cycleDays">
        <el-input-number
          v-model="info.cycleDays"
          :precision="0"
          :min="0"
        ></el-input-number
        >天
      </el-form-item>
      <el-form-item
        label="备注："
        prop="remarks">
        <el-input
          v-model="info.remarks"
          type="textarea"
          :rows="4"
          :autosize="{ minRows: 2, maxRows: 4}"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import CategorySelect from '../../components/category-select-new.vue'
import ServiceSelect from '../../components/service-select.vue'
import CategoryServiceSelectNew from '../../components/category-service-select-new.vue'
import CategoryServiceSelectNew2 from '../../components/category-service-select-new2.vue'
// import DeliverySelect from '../../components/delivery-select.vue'
import LabSelect from '../../components/lab-select.vue'
import { mapState } from 'vuex'
export default {
  name: 'EditAcceptanceModal',
  components: { CategorySelect, ServiceSelect, CategoryServiceSelectNew, CategoryServiceSelectNew2, LabSelect },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      serviceInfo: {},
      info: {
        inspectionNeedId: null,
        workOrderId: null,
        vendorId: null,
        vendorName: null,
        serviceId: null,
        classId: [],
        serviceCategoryId: null,
        sampleDeliveryAddressId: null,
        labId: null,
        features: '',
        testStandard: null,
        testQualification: null,
        sampleQuantity: null,
        cycleDays: undefined,
        remarks: ''
      },
      flag: -1,
      rules: {
        serviceId: [
          { required: true, message: '请选择服务产品', trigger: 'change' }
        ],
        classId: [
          { required: true, message: '请选择行业管理', trigger: 'change' }
        ],
        serviceCategoryId: [
          { required: true, message: '请选择二级类目及套餐', trigger: 'change' }
        ],
        testStandard: [
          // { required: true, message: '请输入检测标准', trigger: 'blur' },
          { max: 100, message: '检测标准长度最多 100 个字符', trigger: 'blur' }
        ],
        features: [
          { required: true, message: '请输入检测内容/描述', trigger: 'blur' },
          { max: 200, message: '检测内容/描述长度最多 200 个字符', trigger: 'blur' }
        ],
        testQualification: [
          // { required: true, message: '请输入检测资质', trigger: 'blur' },
          { max: 100, message: '长度最多 100 个字符', trigger: 'blur' }
        ],
        sampleQuantity: [
          // { required: true, message: '请输入抽样数量', trigger: 'blur' },
          { max: 100, message: '抽样数量长度最多 100 个字符', trigger: 'blur' }
        ],
        cycleDays: [
          { required: false, message: '请输入服务周期', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    }),
    title() {
      const workOrderId = this.info.workOrderId
      return (workOrderId ? '编辑' : '新增') + '受理单'
    },
    options() {
      const { serviceId, classId } = this.info
      return {
        serviceId, classId
      }
    }
  },
  methods: {
    cb(r) {
      console.log('--------------------------------', r)
      this.flag = r.needConfigPackage
      this.serviceInfo = r
    },
    packageCallback(row) {
      this.info.features = row.features
      this.info.testStandard = row.testStandard
      this.info.testQualification = row.testQualification
      this.info.sampleQuantity = row.sampleQuantity
      this.info.cycleDays = row.cycleDays || undefined
    },
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.info = {
        inspectionNeedId: null,
        vendorId: null,
        vendorName: null,
        serviceId: null,
        classId: [],
        serviceCategoryId: null,
        sampleDeliveryAddressId: null,
        labId: null,
        features: '',
        testStandard: null,
        testQualification: null,
        sampleQuantity: null,
        cycleDays: undefined,
        remarks: ''
      }
      this.flag = -1
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const { inspectionNeedId, workOrderId, vendorId, serviceId, classId, serviceCategoryId, sampleDeliveryAddressId, labId, features, testStandard, testQualification, sampleQuantity, cycleDays, remarks } = this.info
          this.loading = true
          const dispatch = this.info.workOrderId
            ? 'updateworkorder'
            : 'addworkorder'
          this.$store.dispatch(`account/${dispatch}`, {
            payload: {
              inspectionNeedId,
              workOrderId,
              vendorId,
              serviceId,
              sgsId: this.userInfo.orgId,
              acceptStaffId: this.userInfo.userId,
              classIdLevel1: classId[0] || null,
              classIdLevel2: classId[1] || null,
              serviceCategoryId: this.flag === 0 ? serviceCategoryId : (serviceCategoryId[0] || null),
              servicePackageId: this.flag === 0 ? null : (serviceCategoryId[1] || null),
              sampleDeliveryAddressId,
              labId,
              features,
              testStandard,
              testQualification,
              sampleQuantity,
              cycleDays: cycleDays || 0,
              remarks
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    add(options = {}) {
      this.flag = -1
      this.info = {
        ...this.info,
        ...options
      }
      this.toggleModal(true)
    },
    update(options = {}) {
      console.log(options)
      this.flag = Array.isArray(options.serviceCategoryId) ? 1 : 0
      this.info = {
        // ...this.info,
        ...options
      }
      setTimeout(() => {
        this.toggleModal(true)
      }, 20)
    }
  }
}
</script>
